/**
 * @generated SignedSource<<980b99f9858938ed3b9c40cee0ef6ef4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    };
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment";
};
export type CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment$key = {
  readonly " $data"?: CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateFachberaterRewardButton_CertificateTemplatesConnectionV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CertificateTemplatesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CertificateTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CertificateTemplatesConnection",
  "abstractKey": null
};

(node as any).hash = "8cd928d27a8529262497e30d8468fd56";

export default node;
